import { AuthState } from './types'

export const initState = (): AuthState => ({
  isAuthenticated: false,
  appReady: true,
})

export default initState
